import {isNilOrEmpty, isString} from 'ramda-adjunct';

import {EMPTY_PLACEHOLDER} from '../constants/placeholders';

export function valueOrPlaceholder<T>(value: T) {
  if (isString(value) && value.trim() === '') {
    return EMPTY_PLACEHOLDER;
  }

  return isNilOrEmpty(value) ? EMPTY_PLACEHOLDER : (value as NonNullable<T>);
}
